import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import {
  applicantFileUploadAction,
  applicantIncludeAppealCommentLogAction,
  resetAppealComment,
  updateAppealComment,
} from "@actions/ApplicantAction";

import { RootState } from "@reducers";

import EditorAppealComment, { ExternalProps } from "./EditorAppealComment";

const mapStateToProps = (state: RootState, props: ExternalProps) => ({
  isUpdatingAppealComment: state.applicant.isUpdatingAppealComment,
  isUpdateAppealCommentSuccess: state.applicant.isUpdateAppealCommentSuccess,
  isUpdateAppealCommentError: state.applicant.isUpdateAppealCommentError,
  isIncludedAppealCommentLog: state.applicant.isIncludedAppealCommentLog,
  isFileUploading: state.applicant.isFileUploading,
  fileUploadConfig: state.applicant.challengeContext.fileUploadConfig,
  ...props,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  applicantIncludeAppealCommentLogAction: (payload: {} = {}) => {
    dispatch(applicantIncludeAppealCommentLogAction.request(payload));
  },
  updateAppealComment: (payload: {}, params: {}) => {
    dispatch(updateAppealComment.request(payload, params));
  },
  resetAppealCommentState: () => {
    dispatch(resetAppealComment.request());
  },
  updateFileUploadingState: (isUploading: boolean) => {
    if (isUploading) {
      dispatch(applicantFileUploadAction.request());
      return;
    }
    dispatch(applicantFileUploadAction.success());
  },
});

/**
 * Wrapped component
 */
const wrappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditorAppealComment);

export default wrappedComponent;
